'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.popupLinkWidget = function (navigatorShim) {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.addEventListener('click', function (e) {
			const target = e.currentTarget && e.currentTarget.href;
			if (target) {
				navigatorShim.popup(target);
				e.preventDefault();
				e.stopPropagation();
			}
		});
	});
};
